import React from "react";
import HomeSpread from "../Components/HomeSpread/HomeSpread";
import NewProducts from "../Components/NewProducts/NewProducts";

const Home = () => {
  return (
    <div>
      <HomeSpread />
      <NewProducts />
    </div>
  );
};

export default Home;
